var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68068 24.6953C6.07306 24.6953 5.55292 24.479 5.12024 24.0463C4.68754 23.6136 4.47119 23.0935 4.47119 22.4858V11.5048C4.47119 11.1553 4.54975 10.8241 4.70686 10.5113C4.86397 10.1986 5.0811 9.94071 5.35824 9.73767L12.6704 4.2518C12.874 4.10513 13.0879 3.99435 13.3119 3.91945C13.5359 3.84457 13.7666 3.80713 14.004 3.80713C14.2415 3.80713 14.4712 3.84457 14.6932 3.91945C14.9152 3.99435 15.1272 4.10513 15.3292 4.2518L22.6414 9.73767C22.9197 9.94239 23.1379 10.2009 23.2959 10.5131C23.454 10.8253 23.5331 11.1558 23.5331 11.5048V22.4858C23.5331 23.0935 23.3163 23.6136 22.8827 24.0463C22.4491 24.479 21.9279 24.6953 21.319 24.6953H16.3796V16.2869H11.62V24.6953H6.68068Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressHome);
export default __webpack_public_path__ + "static/media/pressHome.1e5f45f5.svg";
export { ForwardRef as ReactComponent };